module.exports = __webpack_public_path__ + "static/media/29COICT2.2e47e69c.jpg";